import * as  React from 'react';
import {connect} from "react-redux";
import {fetchRequest} from "@actions/menu";
import {getMenusList} from '@reducers/menu';

/**
 * This class checks if menus has not fetched yet, fetch Table
 * Get menus Table from store and inject it as a props to the component.
 * @param Component
 */
const menuMultiSelectionFetcherHoc = <P extends object>(Component: React.ComponentType<P>) =>{
  
  class MenuMultiSelectionFetcher extends React.Component<P> {
    
    constructor(props) {
      super(props);
    }
    
    state = {
      currentPage : 1,
      data        : [],
      count       : 0
    };
    
    componentDidMount(){
      const {is_fetched, fetchRequest} = this.props;
      if (!is_fetched) {
        fetchRequest({
          params: {
            offset: 0,
            count: 200}
        });
      }
    }
    
    render() {
      return (
        <Component  {...this.props as P}
                    data={this.props.data}/>
      )
    }
  }
  
  const mapStateToProps = ({ menus }) => {
    return {
      is_fetched: menus.is_fetched,
      data: getMenusList(menus)
    };
  };
  
  const mapDispatchToProps = {
    fetchRequest
  };
  
  return connect(mapStateToProps, mapDispatchToProps)(MenuMultiSelectionFetcher);
};


export default menuMultiSelectionFetcherHoc;